import { render, staticRenderFns } from "./cascader-widget.vue?vue&type=template&id=9fb36e9a&scoped=true&"
import script from "./cascader-widget.vue?vue&type=script&lang=js&"
export * from "./cascader-widget.vue?vue&type=script&lang=js&"
import style0 from "./cascader-widget.vue?vue&type=style&index=0&id=9fb36e9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb36e9a",
  null
  
)

export default component.exports